import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'CloseButton',
  setup(__props) {

const filtersStore = useFiltersStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "serp__filters--mobile-close-button q-d-block q-d-md-none q-btn q-btn-close q-btn-lg q-rounded-3 q-shadow-sm q-bg-white q-p-3",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(filtersStore).hideFiltersOnMobile && _unref(filtersStore).hideFiltersOnMobile(...args)))
  }))
}
}

})